import { Component, ContentChild, Input, ViewChild } from '@angular/core';
import { OpsAccordionComponent } from '../ops-accordion/ops-accordion.component';

@Component({
    selector: 'app-form-accordion',
    templateUrl: './form-accordion.component.html',
    styleUrls: ['./form-accordion.component.scss'],
    standalone: false
})
export class FormAccordionComponent {
    @ViewChild('accordion', { static: true }) accordion: OpsAccordionComponent;

    @Input() header: string = '';
    @Input() isOpen: boolean = false;
    @Input() showErrorBorder: boolean = false;

    setOpen(open: boolean) {
        this.isOpen = open;

        if (this.accordion) {
            this.accordion.setOpen(open);
        }
    }
}
